module.exports = __webpack_public_path__ + "static/real-time-tracking-3d73f663e256a042c7895be5aa53d046.png";